import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withKeys as _withKeys, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "container px-0" }, null, -1)
const _hoisted_4 = { class: "container px-0" }
const _hoisted_5 = { class: "row fv-row mb-2 mt-2" }
const _hoisted_6 = { class: "col-sm-12 col-md-10 mb-1" }
const _hoisted_7 = { class: "col-sm-12 col-md-2 mb-1 float-end" }
const _hoisted_8 = { class: "card-title align-items-start flex-column mt-0 text-right" }
const _hoisted_9 = { class: "d-flex col-md-10" }
const _hoisted_10 = ["hidden"]
const _hoisted_11 = {
  key: 0,
  class: "d-flex align-items-center position-relative"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_13 = { class: "row fv-row mb-2 mt-2" }
const _hoisted_14 = { class: "col-sm-6 col-md-2" }
const _hoisted_15 = {
  key: 0,
  class: "d-flex align-items-center position-relative"
}
const _hoisted_16 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_17 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex align-items-center position-relative"
}
const _hoisted_19 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_20 = { class: "col-sm-6 col-md-3 mb-1" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex align-items-center position-relative"
}
const _hoisted_22 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_23 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_24 = {
  key: 0,
  class: "d-flex align-items-center position-relative"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Status", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "true" }, "Sudah", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "false" }, "Belum", -1)
const _hoisted_28 = { class: "card-body py-3" }
const _hoisted_29 = { class: "table-responsive" }
const _hoisted_30 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_31 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nomor Identitas", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tags", -1)
const _hoisted_35 = { class: "min-w-125px; text-center" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" NFC Id")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Mapping", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi", -1)
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "text-left pl-3" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = ["id", "onUpdate:modelValue", "onKeyup"]
const _hoisted_45 = ["id", "onUpdate:modelValue"]
const _hoisted_46 = { class: "text-center" }
const _hoisted_47 = { class: "text-center" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "row mt-5 mb-5" }
const _hoisted_53 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_54 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_55 = ["label", "value"]
const _hoisted_56 = { class: "p-3" }
const _hoisted_57 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_58 = { class: "pagination" }
const _hoisted_59 = { class: "row mt-5 mb-5" }
const _hoisted_60 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_2"
}
const _hoisted_61 = { class: "modal-dialog" }
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = { class: "modal-header" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, "View", -1)
const _hoisted_65 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_66 = { class: "svg-icon svg-icon-2x" }
const _hoisted_67 = { class: "modal-body row" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Nama ", -1)
const _hoisted_69 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_70 = { class: "col-12" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Nomor Identitas ", -1)
const _hoisted_72 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_73 = { class: "col-12" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " tags ", -1)
const _hoisted_75 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_76 = { class: "col-12" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " NFC ID ", -1)
const _hoisted_78 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_79 = { class: "col-12" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Executor ", -1)
const _hoisted_81 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_82 = { class: "col-12" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Last Update NFC ID ", -1)
const _hoisted_84 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_85 = { class: "col-12" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary",
    "data-bs-dismiss": "modal"
  }, " OK ")
], -1)

export function render(_ctx: any,_cache: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-light",
                style: {"font-weight":"400","margin-top":"0px"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showHideFilter && _ctx.showHideFilter(...args)))
              }, " Filter "),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h3", _hoisted_8, [
                  (_ctx.aksesDownload == true)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
                        class: "btn btn-md btn-primary"
                      }, " Download "))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "mb-1",
                hidden: _ctx.role === 'ADMIN_SCHOOL' ? true : false
              }, [
                (_ctx.showFilter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.companyId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyId) = $event)),
                        placeholder: "Pilih Company Dahulu",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.listCompany,
                        searchable: true,
                        label: "name",
                        "track-by": "name",
                        "value-prop": "_id",
                        style: {"width":"600px"},
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pilihCompany($event)))
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_10),
              _hoisted_12
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_ctx.showFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control ps-15",
                      placeholder: "Cari Nama",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.nama) = $event)),
                      onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.eventDelaySearch(_ctx.e)))
                    }, null, 544), [
                      [_vModelText, _ctx.nama]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              (_ctx.showFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control ps-15",
                      placeholder: "Filter Tag",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tag) = $event)),
                      onKeyup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.eventDelaySearch(_ctx.e)))
                    }, null, 544), [
                      [_vModelText, _ctx.tag]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_ctx.showFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control ps-15",
                      placeholder: "Filter Nomor Identitas",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.nisFilter) = $event)),
                      onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeNIS(_ctx.e)))
                    }, null, 544), [
                      [_vModelText, _ctx.nisFilter]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_ctx.showFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(_component_Field, {
                      as: "select",
                      class: "form-select form-select-lg fw-bold",
                      name: "province",
                      autocomplete: "off",
                      modelValue: _ctx.status,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.status) = $event)),
                      onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeStatus($event)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25,
                        _hoisted_26,
                        _hoisted_27
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("table", _hoisted_30, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_31, [
                _hoisted_32,
                _hoisted_33,
                _hoisted_34,
                _createElementVNode("th", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("i", {
                    class: "bi bi-caret-down-fill text-right",
                    style: {"align-self":"baseline","cursor":"pointer"},
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortnfc()))
                  })
                ]),
                _hoisted_37,
                _hoisted_38
              ])
            ]),
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_40, _toDisplayString(item.callerName), 1),
                      _createElementVNode("td", _hoisted_41, _toDisplayString(item.callerId), 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString(item.tags), 1),
                      _createElementVNode("td", _hoisted_43, [
                        (_ctx.aksesEditNFCID == true)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              id: _ctx.setID(item.id),
                              type: "text",
                              class: "input-items",
                              placeholder: "Tap NFC Id",
                              "onUpdate:modelValue": ($event: any) => ((item.nfcId) = $event),
                              ref: "nfc",
                              onfocus: "this.select()",
                              onKeyup: _withKeys(($event: any) => (_ctx.onChangeNFC(item)), ["enter"])
                            }, null, 40, _hoisted_44)), [
                              [_vModelText, item.nfcId]
                            ])
                          : _createCommentVNode("", true),
                        (_ctx.aksesEditNFCID == false)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 1,
                              id: _ctx.setID(item.id),
                              type: "text",
                              class: "input-items",
                              placeholder: "Tap NFC Id",
                              "onUpdate:modelValue": ($event: any) => ((item.nfcId) = $event),
                              ref: "nfc",
                              onfocus: "this.select()",
                              disabled: ""
                            }, null, 8, _hoisted_45)), [
                              [_vModelText, item.nfcId]
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.cekStatusNFC(item.nfcId)), 1),
                      _createElementVNode("td", _hoisted_47, [
                        _createElementVNode("a", {
                          class: "btn btn-sm btn-warning",
                          title: "View",
                          style: {"cursor":"pointer"},
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_2",
                          onClick: ($event: any) => (_ctx.clickview(item))
                        }, " view ", 8, _hoisted_48)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_49, _hoisted_51))
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_55))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("ul", _hoisted_58, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("span", _hoisted_66, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _hoisted_68,
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "callerName",
                        class: "form-control form-control-lg",
                        disabled: "",
                        modelValue: _ctx.detail.callerName,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.detail.callerName) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_71,
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "callerId",
                        class: "form-control form-control-lg",
                        disabled: "",
                        modelValue: _ctx.detail.callerId,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.detail.callerId) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_74,
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "tags",
                        class: "form-control form-control-lg",
                        disabled: "",
                        modelValue: _ctx.detail.tags,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.detail.tags) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_77,
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nfcId",
                        class: "form-control form-control-lg",
                        disabled: "",
                        modelValue: _ctx.detail.nfcId,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.detail.nfcId) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_80,
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "createTime",
                        class: "form-control form-control-lg",
                        disabled: "",
                        modelValue: _ctx.detail.lastEditorNfcId,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.detail.lastEditorNfcId) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_83,
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "createTime",
                        class: "form-control form-control-lg",
                        disabled: "",
                        modelValue: _ctx.detail.dateTimeUpdate,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.detail.dateTimeUpdate) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _hoisted_86
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}